/**
 * src/helpers/check-holiday.js
 * 祝日の場合、trueを返す
 */

 import moment from 'moment'
 import  holidaysList from '../i18n/holidays-ja'

 export default function isHoliday(date) {
  const checkDate = moment(date).format('MM-DD')
  const checkYear = moment(date).year()

  return  !!(holidaysList[checkYear] && holidaysList[checkYear][checkDate])
 }




// WEBPACK FOOTER //
// ./src/helpers/check-holiday.js